import React, { useReducer } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import transferReducer, { initialState } from './reducer';
import TransferContext from './context';
import TransferWrapper from '../../components/TransferWrapper/TransferWrapper';
import TransferHub from '../../components/Transfer/TransferHub/TransferHub';
import ConfirmationHub from '../../components/Transfer/ConfirmationHub/ConfirmationHub';

const WrappedTransfer = () =>
        <TransferWrapper>
            <TransferHub />
        </TransferWrapper>;

const WrappedConfirm = () =>
    <TransferWrapper confirm>
        <ConfirmationHub />
    </TransferWrapper>;

const TransferContainer = () => {

    const [state, dispatch] = useReducer(transferReducer, initialState);

    return (
        <TransferContext.Provider
            value={{
                state,
                dispatch
            }}
        >
            <BrowserRouter basename="/usis/advice/checkout/transfer">
                <Switch>
                    <Route exact path={["/", "/step-2"]} component={WrappedTransfer} />
                    <Route exact path="/confirmation" component={WrappedConfirm} />
                </Switch>
            </BrowserRouter>
        </TransferContext.Provider>
    );
};

export default TransferContainer;
